import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../../../components/global/modal/withModal';
import Button from '../../../../../../../../components/global/Button';
import AddressListItem from '../../../../../../../../services/cards/components/CardElementAddress/AddressListItem';
import CardSendButton from '../CardSendButton';

const propTypes = {
  recipients: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      address_line_1: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  price: PropTypes.shape({
    total_price: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
  }),
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

const RecipientsReviewModal = ({ recipients, price, onConfirm, onDismiss }) => {
  return (
    <div className="global-wg-configurator-review">
      <div className="global-wg-configurator-review-header">
        <h4 className="mb-1">Review recipients</h4>

        <p>Your Card is ready to be sent to the following addresses:</p>
      </div>

      <div className="global-wg-configurator-review-scroll">
        <div className="address-list-items">
          {recipients.map(recipient => (
            <AddressListItem key={recipient.id} address={recipient} />
          ))}
        </div>
      </div>

      <CardSendButton
        className="mt-3"
        recipients={recipients}
        onCardSend={onConfirm}
        price={price}
      />

      <Button
        btnBlock
        className="mt-1 text-center"
        btnStyle="link"
        onClick={onDismiss}
      >
        Cancel
      </Button>
    </div>
  );
};

RecipientsReviewModal.propTypes = propTypes;

export default withModal(RecipientsReviewModal, {
  hideHeader: true,
  size: 'xs',
  className: 'global-wg-configurator-review-modal',
});
